// src/pages/LandingPage.js
import React, { useEffect, useState, useRef, useContext } from 'react';
import {
  Box, Grid, Typography, TextField, Button,
  AppBar, Toolbar, MenuItem, CircularProgress
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import api from '../api/api';
import logo from '../assets/images/logo.png';
import formImage from '../assets/images/form-banner.jpg';

const LandingPage = () => {
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [formData, setFormData] = useState({ nombre: '', contacto: '', servicio: '', ubicacion: '' });
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const serviciosRef = useRef(null);
  const beneficiosRef = useRef(null);

  useEffect(() => {
    api.get('/services')
      .then(res => {
        const sortedServices = res.data.sort((a, b) => a.title.localeCompare(b.title));
        setServices(sortedServices);
      })
      .catch(err => console.error('Error al cargar servicios', err))
      .finally(() => setLoading(false));
  }, []);

  const handleLogin = async () => {
    try {
      await login(email, password);
      // La redirección la maneja App.js según el rol
    } catch (error) {
      // El error ya se maneja dentro del AuthContext
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFormSubmit = () => {
    alert('Para solicitar un servicio necesitás iniciar sesión.');
  };

  const beneficios = [
    {
      title: 'Profesionales verificados',
      description: 'Todos los prestadores pasan controles de calidad.',
      image: require('../assets/images/beneficios/verificados.png')
    },
    {
      title: 'Solicitá desde el celular',
      description: 'Usá Fixo desde cualquier dispositivo.',
      image: require('../assets/images/beneficios/mobile.png')
    },
    {
      title: 'Pagá de forma segura',
      description: 'Aceptamos tarjetas y billeteras electrónicas.',
      image: require('../assets/images/beneficios/seguridad.png')
    },
    {
      title: 'Atención inmediata 24/7',
      description: 'Estamos disponibles para asistirte todos los días.',
      image: require('../assets/images/beneficios/atencion.png')
    }
  ];

  const getIconForLabel = (label) => {
    const fileName = label.toLowerCase().replace(/\s/g, '').replace(/\./g, '').replace(/á/g, 'a').replace(/é/g, 'e').replace(/í/g, 'i').replace(/ó/g, 'o').replace(/ú/g, 'u').replace(/ñ/g, 'n');
    try {
      return require(`../assets/images/icons/${fileName}.png`);
    } catch (e) {
      return require(`../assets/images/icons/default.png`);
    }
  };

  return (
    <Box sx={{ flexGrow: 1, minHeight: '100vh', backgroundColor: '#fff', color: '#000' }}>
      <AppBar position="fixed" sx={{ backgroundColor: '#163244', boxShadow: 1 }}>
        <Toolbar sx={{ justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
          <Box onClick={() => navigate('/')} sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
            <img src={logo} alt="Fixo Logo" height={40} />
          </Box>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'center' }}>
            <TextField size="small" variant="outlined" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} InputProps={{ sx: { backgroundColor: '#fff', fontSize: '0.8rem' } }} sx={{ maxWidth: 160 }} />
            <TextField size="small" variant="outlined" placeholder="Contraseña" type="password" value={password} onChange={(e) => setPassword(e.target.value)} InputProps={{ sx: { backgroundColor: '#fff', fontSize: '0.8rem' } }} sx={{ maxWidth: 160 }} />
            <Button onClick={handleLogin} variant="contained" sx={{ backgroundColor: '#E7A432', color: '#000', fontSize: '0.75rem', px: 2 }}>
              Ingresar
            </Button>
            <Button onClick={() => navigate('/registro')} variant="outlined" sx={{ borderColor: '#E7A432', color: '#E7A432', fontSize: '0.75rem', px: 2 }}>
              Registrarse
            </Button>
          </Box>
          </Toolbar>
          <Box sx={{ backgroundColor: '#E7A432', color: '#163244', px: 4, py: 1 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 4, fontSize: 14, fontWeight: 500 }}>
                      <Typography sx={{ cursor: 'pointer' }}>Quienes somos</Typography>
                      <Typography sx={{ cursor: 'pointer' }}>¿Querés ser parte de Fixo?</Typography>
                      <Typography sx={{ cursor: 'pointer' }} onClick={() => serviciosRef.current.scrollIntoView({ behavior: 'smooth' })}>Servicios</Typography>
                      <Typography sx={{ cursor: 'pointer' }} onClick={() => beneficiosRef.current.scrollIntoView({ behavior: 'smooth' })}>¿Por qué Fixo?</Typography>
                    </Box>
                  </Box>
          </AppBar>

      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, p: 4, mt: 12, gap: 4 }}>
        <Box sx={{ flex: 1 }}>
          <Box component="img" src={formImage} alt="Servicio" sx={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 3 }} />
        </Box>
        <Box sx={{ flex: 1, p: 2, backgroundColor: '#f5f5f5', borderRadius: 2 }}>
          <Typography variant="h6" fontWeight={600} sx={{ mb: 2 }}>
            Solicitá tu servicio ahora
          </Typography>
          <TextField fullWidth name="nombre" label="Nombre completo" variant="outlined" margin="normal" value={formData.nombre} onChange={handleInputChange} />
          <TextField fullWidth name="contacto" label="Email o Teléfono" variant="outlined" margin="normal" value={formData.contacto} onChange={handleInputChange} />
          <TextField
            select
            fullWidth
            name="servicio"
            label="Tipo de servicio"
            variant="outlined"
            margin="normal"
            value={formData.servicio}
            onChange={handleInputChange}
          >
            {services.map((servicio, index) => (
              <MenuItem key={index} value={servicio.title}>{servicio.title}</MenuItem>
            ))}
          </TextField>
          <TextField fullWidth name="ubicacion" label="Ubicación" variant="outlined" margin="normal" value={formData.ubicacion} onChange={handleInputChange} />
          <Button variant="contained" sx={{ mt: 2, backgroundColor: '#E7A432', color: '#000' }} onClick={handleFormSubmit}>
            Solicitar servicio
          </Button>
        </Box>
      </Box>

      {/* Servicios disponibles */}
      <Box ref={serviciosRef} sx={{ px: 4, pb: 6 }}>
        <Typography variant="h5" fontWeight={600} sx={{ mb: 2 }}>Servicios disponibles</Typography>
        {loading ? <CircularProgress /> : (
          <Grid container spacing={2} justifyContent="center">
            {services.map((item, i) => (
              <Grid item xs={6} sm={4} md={2} key={i}>
                <Box
                  sx={{
                    backgroundColor: '#f5f5f5',
                    textAlign: 'center',
                    p: 2,
                    borderRadius: 2,
                    height: 140,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    transition: '0.3s',
                    cursor: 'pointer',
                    '&:hover': { backgroundColor: '#E7A432' }
                  }}
                >
                  <Box component="img" src={getIconForLabel(item.title)} alt={item.title} sx={{ width: 80, height: 80, objectFit: 'contain', mb: 1 }} />
                  <Typography fontWeight={600}>{item.title}</Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        )}
      </Box>

      {/* Beneficios */}
      <Box ref={beneficiosRef} sx={{ px: 4, py: 6, backgroundColor: '#f0f4f8' }}>
        <Typography variant="h5" fontWeight={600} sx={{ mb: 4 }}>¿Por qué elegir Fixo?</Typography>
        <Grid container spacing={0} sx={{ display: 'flex', flexWrap: 'nowrap', overflowX: 'auto' }}>
          {beneficios.map((b, i) => (
            <Grid item xs={12} sm={6} md={3} key={i} sx={{ flex: '0 0 25%' }}>
              <Box
                sx={{
                  backgroundColor: '#f5f5f5',
                  p: 3,
                  borderRadius: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                  minHeight: 250,
                  textAlign: 'center'
                }}
              >
                <Box component="img" src={b.image} alt={b.title} sx={{ width: 80, height: 80, objectFit: 'contain', mb: 2 }} />
                <Typography variant="h6" fontWeight={600} gutterBottom align="center">
                  {b.title}
                </Typography>
                <Typography variant="body2" color="text.secondary" align="center">
                  {b.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default LandingPage;